import * as actionTypes from "../constants/actionTypes";
import createReducer from "../lib/createReducer";
import * as config from "../config";

const defaultState = {  
    registrationMembershipType: localStorage.getItem(config.storageKeys.registrationMembershipType) ? localStorage.getItem(config.storageKeys.registrationMembershipType) : "",
    joinRenewMembershipType: localStorage.getItem(config.storageKeys.joinRenewMembershipType) ? localStorage.getItem(config.storageKeys.joinRenewMembershipType) : "",    
};

function REGISTRATION_MEMBERSHIP_TYPE_STORE(state, action) {
    const { registrationMembershipType } = action;
    return {
        ...state,
        registrationMembershipType,
    }   
}

function MEMBERSHIP_JOIN_RENEW_TYPE_STORE(state, action) {
    const { joinRenewMembershipType } = action;
    return {
        ...state,
        joinRenewMembershipType,
    }   
}

const handlers = {};
handlers[actionTypes.REGISTRATION_MEMBERSHIP_TYPE_STORE] = REGISTRATION_MEMBERSHIP_TYPE_STORE;
handlers[actionTypes.MEMBERSHIP_JOIN_RENEW_TYPE_STORE] = MEMBERSHIP_JOIN_RENEW_TYPE_STORE;
export default createReducer(defaultState, handlers);